import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import config from '../../config';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';

import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import facebookImage from '../../assets/sneakertimeFacebook-1200x630.jpg';
import twitterImage from '../../assets/sneakertimeTwitter-600x314.jpg';

import SectionHero from './SectionHero/SectionHero';
import SectionHeroMobile from './SectionHeroMobile/SectionHeroMobile';
import SectionRotate from './SectionRotate/SectionRotate';
import SectionCurrently from './SectionCurrently/SectionCurrently';
import SectionLatestArrivals from './SectionLatestArrivals/SectionLatestArrivals';
import SectionAnimation from './SectionAnimation/SectionAnimation';
import SectionAnimationMobile from './SectionAnimationMobile/SectionAnimationMobile';

import css from './LandingPage.module.css';

export const LandingPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  const [gateImage, setGateImage] = useState('couchTexture');
  const [isAnimating, setIsAnimating] = useState(true);

  setTimeout(() => {
    setIsAnimating(false);
  }, 3500);

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'LandingPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  const rotateBlock = null;

//  rotateBlock.forEach( item => console.log('item'));

  // Register "ViewContent" event for the Meta Pixel
  console.log("Registering 'ViewContent' Meta Pixel event 'HomePage'");
  if( typeof fbq === "function")
    fbq('track', 'ViewContent', {
      content_ids: ['HomePage'],
      content_name: 'HomePage',
      contents: [{'id': 'HomePage', 'quantity': 1 }],
      currency: 'NZD',
      value: 0
    });

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >

      <SectionAnimation />
      <SectionAnimationMobile />

      <LayoutSingleColumn
        className={`${css.mainWrapperAnimated} ${isAnimating ? css.isAnimating : ''}`}
      >
        <LayoutWrapperTopbar className={css.topbarRoot}>
          <TopbarContainer setGateImage={setGateImage} />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain
          className={css.mainRoot}
        >
          <SectionHero
            gateImage={gateImage}
          />
          <SectionHeroMobile
            gateImage={gateImage}
          />
          <SectionRotate />
          <SectionCurrently />
          <SectionLatestArrivals />

        </LayoutWrapperMain>
        <LayoutWrapperFooter className={css.footer}>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const LandingPage = compose(
  connect(mapStateToProps),
  injectIntl
)(LandingPageComponent);

export default LandingPage;
